export const USER_GROUPS = {
  CLINIC_ADMIN: "clinic_admin",
  CLINIC_ASSISTANT: "clinic_assistant",
  CLINIC_TEAM_LEAD: "clinic_team_lead",
  CLINIC_TEAM_MEMBER: "clinic_team_member",
  CLINICIAN: "clinicians",
  PATIENT: "patients",
  COACH: "coaches",
  ATHLETE: "athletes",
  SUPER_ADMIN: "super_admin",
};

export const USER_GROUPS_TOOLTIP = {
  CLINIC_ADMIN:
    "Clinic Admins are responsible for managing the clinic itself in Allheartz, including creating and managing your web users.",
  CLINIC_ASSISTANT:
    "Clinic Assistants will manage invites for your patients, and the initial assignments of clinical leads for your patient care teams.",
  CLINIC_TEAM_LEAD:
    "Clinic Team Leads will be the primary clinician responsible for a patient. If you want a clinician to be able to assign other clinicians to a patient care team, they should have this role.",
  CLINIC_TEAM_MEMBER:
    "A clinic team member is assigned as a member of a patient care team.",
  CLINICIAN:
    "A clinician has the core permissions required to take care of a patient through Allheartz. Any user with a Clinic Team Lead or Clinic Team Member role should also have a Clinician role.",
  PATIENT: "patients",
};
export const MANAGEMENT_GROUPS = [
  "clinic_admin",
  "clinic_assistant",
  "clinic_team_lead",
  "clinic_team_member",
];

export const CORE_MANAGEMENT_GROUPS = ["clinicians"];

export const enum userOperations {
  EDIT,
  CREATE,
  DELETE,
  INVITE,
}
